import React, {useState, useCallback} from "react";
import classnames from 'classnames/bind';
import styles from './index.module.sass';
import Button from 'components/button';
import {PATH} from 'config';
import {Link, useHistory, useLocation} from 'react-router-dom';
import logo from 'images/icon-pnc-blue.svg';
import Wrapper from 'components/wrapper';
import repo from 'service/repository';
import qs from 'query-string';

const cx = classnames.bind(styles);

const AktzinEntryPage = () => {

    const history = useHistory();
    const location = useLocation();
    const params = qs.parse(location.search);
    const [chargeId, setChargeId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const handleSubmit = useCallback(async (event) => {
        const id = partyId(params);
        const [, data] = await repo.getEvsesByChargeBoxId(`TW*${id}*${chargeId}`);
        if (data) {
            history.push({
                pathname: `${PATH.EVSES}/${data.serialNumber}`
            });
        } else {
            setErrorMessage('充電樁槍號不存在，請確認後重新輸入');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chargeId])

    const partyId = (p) => {
        // 沒有帶入參數時預設為區快充的 CPO party-id
        return p['party_id'] || 'CBK'
    }

    return (
        <Wrapper bgTheme="green-blue">
            <div className={cx({entry: true, loaded: true})}>
                <div className={styles.card}>
                    <div className={styles.logo}>
                        <img src={logo} alt="pick-n-charge-logo"/>
                    </div>
                    <div>
                        <p style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                        }}>輸入充電樁槍號</p>
                        <input
                            style={{
                                margin: '10px 0',
                                padding: '10px',
                                width: '100%',
                            }}
                            maxLength={8}
                            value={chargeId}
                            onChange={(e) => setChargeId(e.target.value)}
                        />
                        {errorMessage && <div className={styles.error}>{errorMessage}</div>}
                    </div>
                    <div>
                        <div className={styles.button}>
                            <Button onClick={() => {
                                handleSubmit()
                            }}>
                                下一步
                            </Button>
                        </div>
                        <div className={styles.agreement}>
                            開始服務即代表同意
                            <Link to={PATH.TERMS}>
                                服務條款
                            </Link>
                            &nbsp;/&nbsp;
                            <Link to={PATH.PRIVACY}>
                                隱私權政策
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}

export default AktzinEntryPage